// Path: ./src/utils/authTokenStorage.ts
import {
  safeLocalStorageGetItem,
  safeLocalStorageRemoveItem,
  safeLocalStorageSetItem,
  safeSessionStorageGetItem,
  safeSessionStorageRemoveItem,
  safeSessionStorageSetItem,
} from "./localStorage";

export const JWT_TOKEN_KEY = "jwtToken";

const getCookie = (key: string): string | null => {
  try {
    const match = document.cookie.match(
      new RegExp(
        `(?:^|; )${key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}=([^;]*)`,
      ),
    );
    return match ? decodeURIComponent(match[1]) : null;
  } catch {
    return null;
  }
};

const setCookie = (key: string, value: string): void => {
  try {
    document.cookie = `${key}=${encodeURIComponent(value)};path=/;SameSite=Lax`;
  } catch {
    // cookies may be blocked in strict privacy contexts
  }
};

const removeCookie = (key: string): void => {
  try {
    document.cookie = `${key}=;path=/;SameSite=Lax;max-age=0`;
  } catch {
    // cookies may be blocked in strict privacy contexts
  }
};

export const getAuthToken = (): string | null => {
  return (
    safeLocalStorageGetItem(JWT_TOKEN_KEY) ??
    safeSessionStorageGetItem(JWT_TOKEN_KEY) ??
    getCookie(JWT_TOKEN_KEY)
  );
};

export const setAuthToken = (token: string): void => {
  safeLocalStorageSetItem(JWT_TOKEN_KEY, token);
  safeSessionStorageSetItem(JWT_TOKEN_KEY, token);
  setCookie(JWT_TOKEN_KEY, token);
};

export const clearAuthToken = (): void => {
  safeLocalStorageRemoveItem(JWT_TOKEN_KEY);
  safeSessionStorageRemoveItem(JWT_TOKEN_KEY);
  removeCookie(JWT_TOKEN_KEY);
};
